"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const _1 = require("../.");
/**
 * A range input where user chooses a value by moving a dot on a trail.
 */
const Slider = ({ name, value, mandatory, setValue, min = 0, max = 300, step = 1, unit, }) => {
    const classes = useStyles();
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("input", { className: classes.input, type: 'range', name: name, value: value || 0, min: min, max: max, onChange: (e) => {
                const newVal = Math.floor(parseInt(e.target.value) / step);
                setValue(name, newVal * step, mandatory, { touched: true });
            } }),
        react_1.default.createElement("div", { className: classes.value },
            value || '0',
            unit && ` ${unit}`)));
};
const useStyles = (0, react_jss_1.createUseStyles)((theme) => ({
    input: {
        padding: 0,
        '-webkit-appearance': 'none',
        display: 'flex',
        width: '100%',
        cursor: 'pointer',
        height: theme.sizes.inputHeight,
        marginBottom: -5,
        backgroundColor: 'transparent',
        '&:focus': {
            outline: 'none',
        },
        '&::-webkit-slider-runnable-track': {
            backgroundColor: theme.colors.inputBorder,
            boxShadow: '0 0 60px 15px white',
            height: 6,
        },
        '&::-webkit-slider-thumb': {
            width: 12,
            height: 12,
            borderRadius: 6,
            marginTop: -3,
            backgroundColor: theme.colors.accent,
            border: 'none',
            '-webkit-appearance': 'none',
        },
    },
    value: {
        color: theme.colors.inputText,
        fontSize: 13,
        textAlign: 'right',
        whiteSpace: 'nowrap',
        position: 'absolute',
        top: -3,
        right: 0,
    },
}));
exports.default = (0, _1.withFormControl)(Slider);
